import {basePostRequest} from "../base/basePostRequest";
import {projectType} from "./getProjects";

const postProject = async (project: projectType) =>
  basePostRequest<projectType>(`/project/`, project);

export default postProject;
